<main>
  <header>
    <div class="row-start-center gap-3">
      <h1>{{ 'Costs_Pools_Title' | translateWF: 'Pools' }}</h1>
    </div>
  </header>

  <div class="content">
    <p-panel header="Filters">
      <p-card>
        <div class="grid-auto-4">
          <div class="form-box">
            <label>{{ 'Year' | translateWF: 'Year' }}</label>
            <p-inputNumber class="w-full" [formControl]="yearControl" styleClass="w-full" inputStyleClass="w-full" [useGrouping]="false" [min]="2020" [max]="2099" />
          </div>
          <div class="form-box">
            <label>{{ 'Month' | translateWF: 'Month' }}</label>
            <p-dropdown class="w-full" [formControl]="monthControl" [options]="monthOptions" optionLabel="label" optionValue="value" styleClass="w-full">
              <ng-template let-option pTemplate="item">
                <span>{{ option.key | translateWF: option.label }}</span>
              </ng-template>
              <ng-template let-option pTemplate="selectedItem">
                <span>{{ option.key | translateWF: option.label }}</span>
              </ng-template>
            </p-dropdown>
          </div>
        </div>
      </p-card>
    </p-panel>

    <div>
      <app-pool-readiness-banner [year]="currentYear()" [month]="currentMonth()" />
    </div>

    @if (excludedTotal() > 0) {
      <p-message severity="warn" styleClass="w-full">
        <div class="col-sm text-sm">
          <span class="font-medium">
            {{
              'Cost_Analysis_Excluded_Banner'
                | translateWF
                  : 'Rolls pending Finishing or with non-Fabric Item Masters are
          excluded from costing.'
            }}
          </span>
          <span class="text-xs">
            <span class="font-semibold tabular-nums">{{ excludedTotal() }}</span>
            {{ 'Cost_Analysis_Excluded_Total' | translateWF: 'rolls excluded' }}
            <span class="opacity-80">
              ({{ 'Cost_Analysis_Excluded_Greige' | translateWF: 'Greige' }}:
              <span class="tabular-nums">{{ excludedCounts().greige }}</span>
              · {{ 'Cost_Analysis_Excluded_Yarn' | translateWF: 'Yarn' }}:
              <span class="tabular-nums">{{ excludedCounts().yarn }}</span>
              · {{ 'Cost_Analysis_Excluded_Unknown' | translateWF: 'Unknown' }}: <span class="tabular-nums">{{ excludedCounts().unknown }}</span
              >)
            </span>
          </span>
        </div>
      </p-message>
    }

    <app-pool-control [year]="currentYear()" [month]="currentMonth()" (calculated)="onCalculated()" />
  </div>
</main>
